import { render } from "./LastNews.vue?vue&type=template&id=1d709582&scoped=true"
import script from "./LastNews.vue?vue&type=script&lang=js"
export * from "./LastNews.vue?vue&type=script&lang=js"

import "./LastNews.vue?vue&type=style&index=0&id=1d709582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d709582"]])

export default __exports__